// number comma format and convert to thai format

export const numberFormat = (num: number) => {
    if(typeof num === 'number' ){
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }else{
        return num;
    }
};

//string to comma format
export const stringToCommaFormat = (num: string) => {
    if(typeof num === 'string' ){
        return num.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }else{
        return num;
    }
}

  export const stringWithCommaFormat = (num: string) => {
    const numf = parseFloat(num);
  
    if (!isNaN(numf)) {
      return numf.toLocaleString("en-US"); 
    } else {
      return num; 
    }
  };

  


    